import { render, staticRenderFns } from "./check_detail.vue?vue&type=template&id=edfeb468&scoped=true&"
import script from "./check_detail.vue?vue&type=script&lang=js&"
export * from "./check_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfeb468",
  null
  
)

export default component.exports